/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { validateYupSchema } from 'formik';
import { bankObject } from '../../components/investors/bankDetails';
//import { getDocumentDetails } from '../../components/investors/documentDetails';
import { contactPersonObject } from '../../components/NonIndividualInvestor/ContactDetails';
import { document_object } from '../../components/NonIndividualInvestor/DocumentDetails';
import { percentageError } from '../../components/NonIndividualInvestor/ubo';
import {
  ADD_UBO_EXCEPTION,
  applicantStatusMasters,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  IS_PENNYDROP_APPLICABLE_FOR_AMC,
  NEXEDGE_MDMS_APIS,
  occupationDetailsMasters,
  onboardingTypeMasters,
  relatedRelations,
  salutationsMasters,
  uboOccupationDetailsMasters,
  USER_ROLES,
} from '../../utils/constant';
import { emailRegex, individualPanRegex } from '../../utils/regex';
import {
  bankDetailsSchema,
  personalDetailsSchema,
  documentDetailsSchema,
  FATCAValidationSchema,
  KYCDetailsSchema,
  nomineeDetailsSchema,
  nonIndividualContactDetailsSchema,
  NonIndividualContributorValidationSchema,
  nonIndividualDocumentDetailsSchema,
  relatedPersonSchema,
} from '../../utils/schema';
import {
  encodeBase64,
  getAddressData,
  getNomineeRelation,
  getNomineeRelationship,
  getOccupationType,
  getRelation,
  isMinor,
  isOnboardingTypeMinor,
  relatedPersonPanValidation,
} from '../../utils/utilityFunctions';
import {
  AuthorisedErrors,
  BankError,
  CALL_API,
  RelatedPersonError,
  RiskProfileErrors,
  UboErrors,
} from '../middleware';
import { useDispatch, useSelector } from 'react-redux';

import {
  Applicant,
  ApplicationProps,
  Bank,
  NomineeType,
  Document,
  uboTypes,
  FetchUBORequestBody,
  StampPapersType,
  dashboardOnboardingType,
  monthwiseOnboardingSummaryType,
  distributorWisecommitmentType,
  monthwiseCommitmentAmountType,
  ubo,
  FatcaMdms,
  individuals_Poa_nonIndividuals_Documents,
  Groups,
  GroupSignatories,
  RiskProfileMasterType,
  CreateApplicationProps,
  DataMaster,
  dataTypeMasters,
  UpdateChequeStatusRequestBody,
  UpdateChequeStatusResponseBody,
  // clientInvInf,
} from '../types/api-types';
import {
  CreateApplicationRequestBody,
  CREATE_APPLICATION,
  CREATE_APPLICATION_SUCCESS,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_ALL_APPLICATION_SUCCESS,
  GET_STAMPPAPER_DETAILS_SUCCESS,
  GET_STAMPPAPER_DETAILS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT,
  GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS,
  GET_MONTHWISE_COMMITMENTAMOUNT,
  GET_ONBOARDING_SUMMARY_SUCCESS,
  GET_ONBOARDING_SUMMARY,
  GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS,
  GET_MONTHWISE_ONBOARDING_SUMMARY,
  GET_ALL_APPLICATION,
  UPDATE_APPLICATION_SUCCESS,
  UPDATE_APPLICATION,
  AddJointHolderRequestBody,
  ADD_APPLICANT_SUCCESS,
  ADD_APPLICANT,
  GetAllApplicantsRequestBody,
  GetAllApplicantionsResponseBody,
  PENNY_DROP_VERIFICATION_SUCCESS,
  PENNY_DROP_VERIFICATION,
  GET_Documents_SUCCESS,
  GET_Documents,
  GET_Ubo_SUCCESS,
  GET_Ubo,
  UBO_LISTING_SUCCESS,
  UBO_LISTING,
  GET_Fatca_SUCCESS,
  GET_Fatca,
  IS_DECLARE_SUCCESS,
  IS_DECLARE,
  UPDATE_CHEQUE_STATUS_SUCCESS,
  UPDATE_CHEQUE_STATUS,
  KRA_REVERIFICATION_SUCCESS,
  KRA_REVERIFICATION,
  KraReverificationResponseBody,
  KraReverificationRequestBody,
  UPDATE_CLIENT_INVESTMENT,
  UPDATE_CLIENT_INVESTMENT_SUCCESS,
  UpdateClientInvestmentRequestBody,
  UpdateClientInvestmentResponseBody,
} from '../types/application';
import { mdmsCountriesList, nationaliyType } from '../types/mdms';
// import { getNationalityList } from './mdms';
import { handleIntialSelect, RiskProfileObj } from '../../components/investors/riskProfileDetails';

export const createApplication =
  (body: CreateApplicationRequestBody) =>
    async (dispatch: any): Promise<CreateApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications`,
          method: 'POST',
          types: [CREATE_APPLICATION_SUCCESS, CREATE_APPLICATION],
          body,
        },
      });
    };

export const getApplicationDetails =
  (applicationId: string, method = '') =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/${applicationId}`,
          method: method ? 'DELETE' : 'GET',
          types: [GET_APPLICATION_SUCCESS, GET_APPLICATION],
        },
      });
    };
export const getParams = (paramsObj: Partial<GetAllApplicantsRequestBody>) => ({
  type: 'GET_PARAMS_DATA',
  paramsObj,
});

export const sendIsDeclareTermsAndConditions =
  (applicantionId: string) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/isDeclareTermsAndConditions/${applicantionId}`,
          method: 'POST',
          types: [IS_DECLARE_SUCCESS, IS_DECLARE],
        },
      });
    };

export const getAllApplications =
  (params: Partial<GetAllApplicantsRequestBody>) =>
    async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
      await dispatch(getParams(params));
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications`,
          method: 'GET',
          types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
          params: {
            limit: 10,
            sort: 'createdAt',
            order: 'DESC',
            ...params,
          },
        },
      });
    };

export const onboardingSummary =
  () =>
    async (dispatch: any): Promise<dashboardOnboardingType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/onboardingSummary`,
          method: 'GET',
          types: [GET_ONBOARDING_SUMMARY_SUCCESS, GET_ONBOARDING_SUMMARY],
        },
      });
    };

export const monthwiseOnboardingSummary =
  () =>
    async (dispatch: any): Promise<monthwiseOnboardingSummaryType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/monthwiseOnboardingSummary?months=4`,
          method: 'GET',
          types: [GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS, GET_MONTHWISE_ONBOARDING_SUMMARY],
        },
      });
    };

export const distributorWisecommitmentAmount =
  () =>
    async (dispatch: any): Promise<distributorWisecommitmentType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/distributorWisecommitmentAmount`,
          method: 'GET',
          types: [GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS, GET_DISTRIBUTOR_COMMITMENTAMOUNT],
        },
      });
    };

export const monthwiseCommitmentAmount =
  () =>
    async (dispatch: any): Promise<monthwiseCommitmentAmountType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/monthwiseCommitmentAmount`,
          method: 'GET',
          types: [GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS, GET_MONTHWISE_COMMITMENTAMOUNT],
        },
      });
    };

// export const getStampPaperCount =
//   (params: Partial<GetAllApplicantsRequestBody>) =>
//   async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/leegality/stampPaperDetails`,
//         method: 'GET',
//         types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],

//       },
//     });
//   };

export const getStampPaperCount =
  () =>
    async (dispatch: any): Promise<StampPapersType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/leegality/stampPaperDetails`,
          method: 'GET',
          types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],
        },
      });
    };

export const updateApplication =
  ({
    body,
    applicationId,
    toastMessage,
  }: {
    body: Partial<ApplicationProps>;
    applicationId: string;
    toastMessage?: string;
  }) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      const showToast = typeof toastMessage !== 'undefined';
      if (showToast) {
        toastMessage =
          `Application ${body.applicationNumber || ''} - ` + (toastMessage || ' Saved successfully');
      }
      try {
        return await dispatch({
          [CALL_API]: {
            url: `/onboarding/applications/${applicationId}/update`,
            method: 'POST',
            types: [UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION],
            body,
            showToast,
            toastMessage,
          },
        });
      } catch (error: any) {
        console.log('catch error on update application', error);
        throw error;
      }
    };

export const addJointHolder =
  (body: AddJointHolderRequestBody, applicationId: string) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/${applicationId}/addApplicant`,
          method: 'POST',
          types: [ADD_APPLICANT_SUCCESS, ADD_APPLICANT],
          body,
        },
      });
    };


export const updateClientInvestment =
  ({ applicationId, clientInvInf }: UpdateClientInvestmentRequestBody) =>
    async (dispatch: any): Promise<UpdateClientInvestmentResponseBody> => {
      try {
        return await dispatch({
          [CALL_API]: {
            url: `/onboarding/applications/update-client-investment`,
            method: 'POST',
            types: [UPDATE_CLIENT_INVESTMENT_SUCCESS, UPDATE_CLIENT_INVESTMENT],
            body: {
              applicationId,
              clientInvInf,
            },
          },
        });
      } catch (error: any) {
        console.log('catch error on update client investment', error);
        throw error;
      }
    };

export const validatePersonalDetails = async (applicants: Partial<Applicant>[], role: any, currencyCode: string, company: string, isRMFieldDisabled: boolean) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      ...applicant,
      namePrefix:
        applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
          ? applicant.namePrefix
          : 'Mr.',
      jointApplicantRelation: getRelation(applicant.relationShipWithFirstApplicant)
        ? applicant.relationShipWithFirstApplicant
        : 'Others',
      relationShipWithFirstApplicant: getRelation(applicant.relationShipWithFirstApplicant)
        ? ''
        : applicant.relationShipWithFirstApplicant,
      occupationDetails: applicant.occupationDetails || '',
      maritalStatus: applicant.maritalStatus || '',
     
      // occupationType: getOccupationType(applicant.occupationDetails)
      //   ? applicant.occupationDetails
      //   : 'Others',
      minorDOB: applicant.minorDOB || null,
      minorCountryNameAndCode: applicant.minorCountryNameAndCode || 'India: +91',
      minorNamePrefix: applicant.minorNamePrefix || 'Mr.',
      minorCountryCode: applicant.minorCountryCode || '+91',
      citizenship: applicant.citizenship || '',
      mothersMaiden: applicant.mothersMaiden || '',
      status: applicant.status || 'Individual',
    })),
  };
  try {
    await validateYupSchema(schemaData, personalDetailsSchema(currencyCode, company, isRMFieldDisabled), true, schemaData);
  } catch (error) {
    console.error(error);
    throw `Personal details`;
  }
};

export const validateRelatedPersonDetail = async (applicants: Partial<Applicant>[], role: any, currencyCode: string, company: string) => {
  const schemaData = {
    applicants: applicants,
  };

  try {
    relatedPersonPanValidation(applicants, company);
    await validateYupSchema(schemaData, relatedPersonSchema(currencyCode, company), true, schemaData);
  } catch (error) {
    // if (error instanceof RelatedPersonError) {
    //   throw error;
    // }
    console.error(error);
    throw `Related Person details`;
  }
};

export const validateKYCDetails = async (applicants: Partial<Applicant>[], role: any) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      grossAnnualIncome: applicant.grossAnnualIncome || '',
      politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus
        ? applicant.politicallyExposedPersonStatus
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
          ? ''
          : 'Not Applicable',
      ckycNo: applicant.ckycNo || '',
      // grossAnnualIncomeDate: applicant.grossAnnualIncomeDate || '',
      // netWorthDate: applicant.netWorthDate || '',
      netWorth: applicant.netWorth || '',
      // webtopId: applicant.webtopId || '',
      // occupationType: applicant.occupationType || '',
      occupation: applicant.occupation || '',
      subOccupation: applicant.subOccupation || '',
      otherSubOccupation: applicant.otherSubOccupation || '',
      employer: applicant.employer || '',
      dnd: applicant.dnd || 'NO',
      branch: applicant.branch || '',
      // registrationNumber: applicant.registrationNumber || '',
      deemedOvd: applicant.deemedOvd || false,
      gst: applicant.gst || '',
      wealthSource: applicant.wealthSource || '',
      financialWealth: applicant.financialWealth || '',
      // accountCode: applicant.accountCode || '',
      ucic: applicant.ucic || '',
      // subGroup: applicant.subGroup || '',
      headFamily: applicant.headFamily || 'false',
      onboardingDate: applicant.onboardingDate || ``,
      introducer: applicant.introducer || '',
      introducerSource: applicant.introducerSource || '',
      introducerSubSource: applicant.introducerSubSource || '',
      otherIntroducerSubSource: applicant.otherIntroducerSubSource || '',
      // sourcingRm: applicant.sourcingRm || '',
      effectiveDate: applicant.effectiveDate || ``,
      // servicingRm: applicant.servicingRm || '',
      businessUnit: applicant.businessUnit || '',
      lastReKycDate: applicant.lastReKycDate || ``,
      nextReKycDate: applicant.nextReKycDate || ``,
      category: applicant.category || '',
      familyDetails: applicant.familyDetails || [],
      tataGroupEmployee: applicant.tataGroupEmployee || false,
    })),
  };
  try {
    await validateYupSchema(schemaData, KYCDetailsSchema, true, schemaData);
  } catch (error) {
    console.error(error);
    throw `Additional details ${error}`;
  }
};

export const validateFATCA = async (
  applicants: Partial<Applicant>[],
  role: any,
  nationalitiesMdmsMasters: { countries: dataTypeMasters[] },
  isRMFieldDisabled: boolean
) => {
  const schemaData = {
    applicants: applicants?.map((applicant) => ({
      typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
      taxResidentOfAnyCountryOtherThanIndia:
        applicant.taxResidentOfAnyCountryOtherThanIndia || false,
      placeOfBirth: applicant.placeOfBirth || '',
      countryOfBirth: applicant.countryOfBirth
        ? applicant.countryOfBirth : 'India',
      countryOfNationality: applicant.countryOfNationality
        ? applicant.countryOfNationality : 'India',
      taxCountryName: applicant.taxCountryName || '',
      taxID: applicant.taxID || '',
      idType: applicant.idType || '',
      nameOfEntity: applicant.nameOfEntity || '',
      dateOfIncorporation: applicant.dateOfIncorporation || '',
      cityOfIncorporation: applicant.cityOfIncorporation || '',
      countryOfIncorporation: applicant.countryOfIncorporation || '',
      entityExcemptionCode: applicant.entityExcemptionCode || '',
    })),
    countryDropdown: nationalitiesMdmsMasters.countries,
  };
  try {
    await validateYupSchema(schemaData, FATCAValidationSchema(isRMFieldDisabled), true, schemaData);
  } catch (error) {
    console.error(error);
    throw `FATCA`;
  }
};

export const validateRiskProfile = async (
  application: ApplicationProps | null,
  riskProfileDataMaster: RiskProfileMasterType[],
  isRMFieldDisabled: boolean,
  role: USER_ROLES
) => {
  const {
    riskprofiles = [],
    riskProfileDeclaration = false,
    wishToAddRiskProfile = true,
  } = application?.applicants[0] || {};

  try {
    const schemaData = {
      wishToAddRiskProfile: wishToAddRiskProfile || true,
      riskProfileDeclaration: riskProfileDeclaration || false,
      riskprofiles: riskProfileDataMaster
        ?.map((mdmsProfile) => {
          const existingRiskProfiles = riskprofiles?.filter(
            (risk_profiles) => risk_profiles.question === mdmsProfile.key
          );
          return existingRiskProfiles.length
            ? existingRiskProfiles?.map((existingProfiles) => {
              if (
                existingProfiles.question === mdmsProfile.key &&
                mdmsProfile.isMultiselect === 'true'
              ) {
                const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key);
                const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                let getOtherValue = '';
                const updateOptions = getInvestment.map((ans) => {
                  if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                    getOtherValue = ans.split('_')[0];
                    return `others_${ans.split('_')[1]}`;
                  }
                  return ans;
                });
                return {
                  ...existingProfiles,
                  ...mdmsProfile,
                  values: mdmsProfile.values?.map((value) => {
                    const scoreUpdate = updateOptions
                      .find((investment) => investment?.split('_')[0] === value.key)
                      ?.split('_')[1];

                    return {
                      ...value,
                      score: scoreUpdate ? Number(scoreUpdate) : value.score,
                    };
                  }),
                  InvestmentGoal: updateOptions || [],
                  scoreCal: Number(existingProfiles.scoreText) || 0,
                  otherValue: getOtherValue,
                  answer: getOtherValue
                    ? updateOptions?.toString()?.replace(/,/g, '*')
                    : existingProfiles.answer,
                };
              } else {
                const checkAnswer =
                  existingProfiles.question === mdmsProfile.key &&
                  mdmsProfile.isMultiselect === 'false' &&
                  mdmsProfile.values?.map((value) => value.key).includes(existingProfiles.answer);

                return {
                  ...existingProfiles,
                  ...mdmsProfile,
                  values: mdmsProfile.values?.map((value) => {
                    if (existingProfiles.answer === value.key) {
                      return {
                        ...value,
                        score: Number(existingProfiles.scoreText),
                      };
                    }
                    return value;
                  }),
                  otherValue: checkAnswer ? '' : existingProfiles.answer,
                  answer: checkAnswer ? existingProfiles.answer : 'others',
                };
              }
            })
            : [{ ...RiskProfileObj, question: mdmsProfile.key, ...mdmsProfile }];
        })
        .flat(),
    };

    const checkAllQuestionsAnswered = schemaData.riskprofiles
      ?.map((profile) => {
        const isRequired = profile.required === 'true';
        const hasAnswer = profile.answer !== '';
        return isRMFieldDisabled ? true : (isRequired ? hasAnswer : true);
      })
      ?.every((_profile) => _profile);

    if (wishToAddRiskProfile && !checkAllQuestionsAnswered) {
      throw new RiskProfileErrors('In Risk Profile Please fill all the required(*) fields');
    }
    schemaData.riskprofiles?.map((risk) => {
      if (
        wishToAddRiskProfile &&
        (risk.answer === 'others' ||
          (risk.isMultiselect === 'true' && risk.answer.includes('others'))) &&
        !risk.otherValue &&
        risk.required === 'true'
      ) {
        const questionForDisplay = riskProfileDataMaster
          ?.map((riskProfile) => {
            if (riskProfile.key === risk.question) {
              return riskProfile.displayText;
            }
            return;
          })
          ?.filter((ele) => ele)
          ?.toString();
        throw new RiskProfileErrors(
          'In Risk Profile Please specify others in ' + questionForDisplay
        );
      }
    });
    if (wishToAddRiskProfile && !riskProfileDeclaration && [USER_ROLES.INVESTOR].includes(role)) {
      throw new RiskProfileErrors('In Risk Profile Declaration is required');
    }
    // await validateYupSchema(schemaData, riskProfileScheme, true, schemaData);
  } catch (e) {
    console.error(e);
    if (e instanceof RiskProfileErrors) {
      throw e;
    }
  }
};

export const validateNomineeDetails = async (
  Nominees: Partial<NomineeType>[],
  doNotWishToNominate: boolean,
  applicants: Partial<Applicant>[],
  onboardingType: string,
  currencyCode: string,
  company: string,
  relationMaster: string[],
  nomineesSOA:string| boolean | null
) => {
  const schemaData = {
    doNotWishToNominate: isOnboardingTypeMinor(onboardingType || '')
      ? true
      : Nominees.length
        ? false
        : doNotWishToNominate === null
          ? true
          : doNotWishToNominate,
    nominees: Nominees.length
      ? Nominees.map((nominee) => ({
        ...nominee,
        Relationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
          ? nominee.nomineeRelationship
            ? nominee.nomineeRelationship
            : nominee.nomineeRelationship
          : 'Others',
        nomineeRelationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
          ? ''
          : nominee.nomineeRelationship,
      }))
      : [],
    nomineesSOA:doNotWishToNominate ? null :`${nomineesSOA}`,
  };
  try {
    await validateYupSchema(schemaData, nomineeDetailsSchema(applicants, currencyCode, company), true, schemaData);
  } catch (error) {
    console.error(error);
    throw `Nominee details`;
  }
};

export const validateBankDetails = async (
  bankDetails: Partial<Bank>[],
  verifyPennydrop: boolean,
  applicationType: string,
  applicants: Partial<Applicant>[],
  currencyCode: string,
  application: any,
  isRMFieldDisabled: boolean
) => {
  const schemaData = {
    applicationType: applicationType,
    status: applicants.length ? applicants[0].status : '',
    banks: bankDetails.length
      ? bankDetails.map((bank) => ({ ...bank, defaultBankAccount: !!bank.defaultBankAccount }))
      : [bankObject],
  };
  try {
    if (IS_PENNYDROP_APPLICABLE_FOR_AMC && verifyPennydrop) {
      const isAllBanksPennyChecked = bankDetails.every((bank) => bank.pennydropCheck);
      if (!isAllBanksPennyChecked) {
        throw new BankError('Please make sure that all the banks are verified');
      }
    }
    await validateYupSchema(schemaData, bankDetailsSchema(applicants, currencyCode, application, isRMFieldDisabled), true, schemaData);
  } catch (error) {
    // if (error instanceof BankError) {
    //   throw error;
    // }
    console.error(error);
    throw `Bank details`;
  }
};

export const validateDocuments = async (
  applicants: Partial<Applicant>[],
  hasPOA: boolean,
  documentsData: Document,
  Nominees: Partial<NomineeType>[],
  isRMFieldDisabled: boolean,
  kycMethod: string,
  permanentAddressSameAsCorresponding: boolean,
  bankRequired: boolean,
  application?: ApplicationProps | null,
) => {
  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {

      const existingIdProofValue = applicant?.documents?.find(obj => obj.documentType === "identityProof")?.documentName ?? ""

      const existingAddressProofValue = applicant?.documents?.find(obj => obj.documentType === "addressProof")?.documentName ?? ""

      const permanentAddressEdited = applicant?.permanentAddressEdited;

      let docData = '';
      if (
        !hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        if (
          onboardingTypeMasters[applicants[0].onboardingType as string] ===
          onboardingTypeMasters.minor
        ) {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
        } else {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
        }
      }
      if (
        hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
      }
      if (
        !hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
      }
      if (
        hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
      }
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? ((documentsData as Document)[docData] || [])
              .filter((doc) => {
                if (
                  hasPOA &&
                  applicant.applicant_type !== '1' &&
                  doc.documentType === 'poaNotarized'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document') {
                  return;
                }
                return document;
              })
              .filter((ele) => ele)
              .filter((doc) => {
                if (
                  applicant.addresses?.find((address) => address.address_type === 'correspondence')?.permanentAddressSameAsCorresponding &&
                  doc.documentType === 'correspondenceAddress' &&
                  !(`${applicant?.status}`.toLowerCase() !== 'individual')
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (
                  !applicant.addresses?.find((address) => address.address_type === 'correspondence')?.permanentAddressSameAsCorresponding &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .map((doc) => {
                if (doc.documentType === 'addressProof') {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (doc.documentType === 'bankAccountProof' && `${application?.banks ?? []}`?.length <= 0) {
                  return { ...doc, required: 'false' };
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (doc.documentType === 'physical_signed_document' && kycMethod === 'osv') {
                  return { ...doc, required: 'true' }
                }
                return doc;
              })
              // to be commented out for bpi client start
              .map((doc) => {
                // if (doc.documentType === 'investorSignature') {
                //   return { ...doc, required: application?.onboardingVia?.toLowerCase() === 'physical' ? "false" : "true" }
                // }

                if (doc.documentType === "investorSignature") {
                  return { ...doc, required: 'false' }
                }
                if (doc.documentType === "identityProof") {
                  return { ...doc, required: (existingIdProofValue === "Aadhaar Card" || existingIdProofValue === "PAN Card") ? "true" : "false" }
                }
                if (doc.documentType === 'addressProof') {
                  return { ...doc, required: (existingAddressProofValue === "Aadhaar Card" || existingAddressProofValue === "PAN Card" || permanentAddressEdited) ? "true" : "false" }
                }
                if (doc.documentType === 'aadhaar_card') {
                  return { ...doc, required: (existingIdProofValue === "Aadhaar Card" || existingAddressProofValue === "Aadhaar Card") ? "false" : "true" }
                }
                if (doc.documentType === 'pan_card') {
                  return { ...doc, required: (existingIdProofValue === "PAN Card" || existingAddressProofValue === "PAN Card") ? "false" : "true" }
                }
                if (doc.documentType === "court_proof_of_guardian") {
                  return { ...doc, required: (applicant?.guardianRelationship === "COURT APPOINTED LEGAL GUARDIAN") ? "true" : "false" }
                }
                return doc
              })
              // to be commented out for bpi client end
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const {
                  documentType,
                  documentName,
                  multipleFiles,
                  required,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                      const {
                        id,
                        documentName = '',
                        documentType = '',
                        documentId = '',
                        isActive = true,
                        file = undefined,
                      } = doc;
                      return {
                        id,
                        applicantId: applicant?.id,
                        documentType,
                        documentName,
                        documentId,
                        isActive,
                        file,
                        options,
                        required,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          ind.toString()) as string,
                      };
                    })
                    : [
                      {
                        documentType,
                        documentName,
                        required,
                        options,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          '0') as string,
                        ...document_object,
                      },
                    ],
                  required,
                  multipleFiles,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                };
              })
            : [],
        onboardingType: applicant.onboardingType,
      };
    }),
    nominees: Nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
              ? [
                ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                  []),
                ...((documentsData as Document)[
                  APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                ] || []),
              ].map((doc) => {
                if (doc.documentType === 'nomineeIdProof') {
                  return { ...doc, required: 'false' };
                }
                return doc;
              })
              : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
            ).map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
              const {
                documentType,
                documentName,
                multipleFiles,
                required,
                options,
                uploadFormats,
                maxFiles,
                maxFileSize,
              } = doc;
              const { nomineedocuments: existingDocuments = [] } = nominee || {};
              const docsOfCurrentDocType = existingDocuments
                .filter((doc) => doc.documentType === documentType)
                .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
              return {
                documentType: documentType,
                documentName: documentName,
                documentsList: docsOfCurrentDocType.length
                  ? docsOfCurrentDocType.map((doc, ind) => {
                    const {
                      id,
                      documentName = '',
                      documentType = '',
                      documentId = '',
                      isActive = true,
                      file = undefined,
                    } = doc;
                    return {
                      id,
                      nomineeId: nominee?.id,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                      options,
                      required,
                      uniqueKey: (nominee_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        ind.toString()) as string,
                    };
                  })
                  : [
                    {
                      documentType,
                      documentName,
                      required,
                      options,
                      uniqueKey: (nominee_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        '0') as string,
                      ...document_object,
                    },
                  ],
                required,
                multipleFiles,
                options,
                uploadFormats,
                maxFiles,
                maxFileSize,
              };
            })
            : [],
      };
    }),
  };
  try {
    await validateYupSchema(schemaData, documentDetailsSchema(isRMFieldDisabled, kycMethod, permanentAddressSameAsCorresponding, bankRequired), true, schemaData);
  } catch (error) {
    console.error(error);
    throw `Document details`;
  }
};

export const isFormValidForSubmission = async (
  application: ApplicationProps | null,
  validateDoc = true,
  verifyPennydrop = true,
  nationalitiesMdmsMasters = {},
  documentsResponse = {},
  role: USER_ROLES = USER_ROLES.INVESTOR,
  riskProfileDataMaster: RiskProfileMasterType[],
  currencyCode = "INR",
  company = "WMS",
  dataMasters: DataMaster = {},
  kycMethod: string,
  permanentAddressSameAsCorresponding: boolean,
  bankRequired: boolean
) => {
  const {
    applicants: applicantsData = [],
    nominees = [],
    doNotWishToNominate = false,
    banks = [],
    hasPOA = true,
    applicationType = '',
    onboardingType = '',
    nomineesSOA = null
  } = application || {};
  const isRMFieldDisabled = role.toLowerCase() !== 'investor';

  const {
    RELATIONSHIP = [],
  } = dataMasters || {} as DataMaster;
  const applicants = applicantsData.filter((applicant) => !applicant.isManuallyAdded);
  const relationMaster = (RELATIONSHIP || []).map((item) => item?.description);
  try {
    await validatePersonalDetails(applicants, role, currencyCode, company, isRMFieldDisabled);
    await validateRelatedPersonDetail(applicants, role, currencyCode, company,);
    await validateKYCDetails(applicants, role);
    await validateNomineeDetails(nominees, doNotWishToNominate, applicants, onboardingType, currencyCode, company, relationMaster,nomineesSOA);
    await validateFATCA(applicants, role, nationalitiesMdmsMasters as { countries: dataTypeMasters[] }, isRMFieldDisabled);
    await validateBankDetails(banks, verifyPennydrop, applicationType, applicants, currencyCode, application, isRMFieldDisabled);
    await validateRiskProfile(application, riskProfileDataMaster, isRMFieldDisabled, role);
    validateDoc &&
      Object.keys(documentsResponse).length !== 0 &&
      (await validateDocuments(applicants, hasPOA, documentsResponse as Document, nominees, isRMFieldDisabled, kycMethod, permanentAddressSameAsCorresponding, bankRequired, application));
  } catch (error) {
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    if (error instanceof RelatedPersonError) {
      throw (error as RelatedPersonError).message;
    }
    if (error instanceof RiskProfileErrors) {
      throw (error as RiskProfileErrors).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};

export const pennyDropVerification =
  (body: Bank) =>
    async (dispatch: any): Promise<Bank> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/pennydropverification`,
          method: 'POST',
          types: [PENNY_DROP_VERIFICATION_SUCCESS, PENNY_DROP_VERIFICATION],
          body,
        },
      });
    };

export const getDocuments =
  () =>
    async (dispatch: any): Promise<Document> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/required_document_master.json`,
          method: 'GET',
          types: [GET_Documents_SUCCESS, GET_Documents],
          modifyUrl: true
        },
      });
    };

export const getUboTypes =
  () =>
    async (dispatch: any): Promise<uboTypes> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/uboTypeMaster.json`,
          method: 'GET',
          types: [GET_Ubo_SUCCESS, GET_Ubo],
          modifyUrl: true
        },
      });
    };

export const FetchData =
  (body: FetchUBORequestBody) =>
    async (dispatch: any): Promise<ubo> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kradetails`,
          method: 'POST',
          types: [UBO_LISTING_SUCCESS, UBO_LISTING],
          body,
        },
      });
    };

export const FatcaMdmsData =
  () =>
    async (dispatch: any): Promise<FatcaMdms> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/fatca_data.json`,
          method: 'GET',
          types: [GET_Fatca_SUCCESS, GET_Fatca],
          modifyUrl: true
        },
      });
    };

export const validateNonIndividualContributorDetails = async (applicants: Partial<Applicant>[], locale: string) => {
  const schemaData = {
    applicants: applicants,
  };
  try {
    await validateYupSchema(schemaData, NonIndividualContributorValidationSchema(locale), true, schemaData);
  } catch (error) {
    throw `Entity details`;
  }
};
export const validateNonIndividualContactDetails = async (
  applicants: Partial<Applicant>[],
  countryDropdown: string[],
  currencyCode = "INR"
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => {
      const correspondence = getAddressData('correspondence', applicant.addresses);
      const permanent = getAddressData('permanent', applicant.addresses);
      const defaultPayload = {
        contactperson: applicant.contactperson
          ? {
            ...applicant.contactperson,
            countryNameAndCode: applicant.contactperson.countryNameAndCode
              ? applicant.contactperson.countryNameAndCode
              : 'India: +91',
            country: applicant.contactperson.country
              ? applicant.contactperson.country.toUpperCase()
              : 'INDIA',
          }
          : contactPersonObject,
        address: {
          correspondence,
        },
      };
      const permanentAddressPayload = correspondence.permanentAddressSameAsCorresponding
        ? defaultPayload
        : {
          ...defaultPayload,
          address: {
            ...defaultPayload.address,
            permanent: {
              ...permanent,
              country: permanent.country ? permanent.country.toUpperCase() : 'INDIA',
            },
            correspondence: {
              ...correspondence,
              country: correspondence.country ? correspondence.country.toUpperCase() : 'INDIA',
            },
          },
        };
      return permanentAddressPayload;
    }),
    countryDropdown: countryDropdown,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualContactDetailsSchema(currencyCode), true, schemaData);
  } catch (error) {
    throw `Contact details`;
  }
};

export const validateNonIndividualDocumentDetails = async (
  applicants: Partial<Applicant>[],
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  banks: Partial<Bank>[]
) => {
  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {
      return {
        documents: documentsData
          .filter((document) => {
            if (applicant.amlCheck && document.documentType === 'compliance_document') {
              return;
            }
            return document;
          })
          .filter((ele) => ele)
          //.map((doc) => ({ ...doc, required: 'true' }))
          .map((doc, index) => {
            const { documentType, documentName, multipleFiles, required, options } = doc;
            const { documents: existingDocuments = [] } = applicant || {};
            const docsOfCurrentDocType = existingDocuments
              .filter((doc) => doc.documentType === documentType)
              .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
            return {
              documentType: documentType,
              documentName: documentName,
              documentsList: docsOfCurrentDocType.length
                ? docsOfCurrentDocType.map((doc, ind) => {
                  const {
                    documentName = '',
                    documentType = '',
                    documentId = '',
                    isActive = true,
                    file = undefined,
                  } = doc;
                  return {
                    documentType,
                    documentName,
                    documentId,
                    isActive,
                    file,
                    options,
                    required,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      ind.toString()) as string,
                  };
                })
                : [
                  {
                    documentType,
                    documentName,
                    required,
                    options,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      '0') as string,
                    ...document_object,
                  },
                ],
              required,
              multipleFiles,
              options,
            };
          }),
      };
    }),
    banks: banks,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualDocumentDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};
const fieldsTocheckForAuthorisedSignatories = [
  {
    key: 'name',
    label: 'Name',
    validateMulitple: false,
  },
  {
    key: 'pan',
    label: 'PAN',
    validateMulitple: true,
    regex: individualPanRegex,
    regexMsg: 'Only Individual PANs are allowed',
  },
  { key: 'mobile', label: 'Mobile Number', validateMulitple: true },
  {
    key: 'email',
    label: 'Email ID',
    validateMulitple: true,
    regex: emailRegex,
  },
  {
    key: 'designation',
    label: 'Designation',
    validateMulitple: false,
  },
];

export const validateNonIndividualAuthorisedSignatories = async (groups: Groups[]) => {
  try {
    groups.map((group) => {
      const getActiveSignatories = group.groupsignatories.filter((item) => item.isActive);
      const getCanEsignCount = getActiveSignatories.filter((item) => item.canEsign);
      if (!getActiveSignatories.length) {
        throw new AuthorisedErrors('Please add Authorised Signatories');
      }
      if (!getCanEsignCount.length) {
        throw new AuthorisedErrors('Please Select a member for E-Sign in Authorised Signatories');
      }
      if (getCanEsignCount.length < group.threshold) {
        throw new AuthorisedErrors(
          'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories'
        );
      }
      getActiveSignatories.forEach((signatory, index) => {
        fieldsTocheckForAuthorisedSignatories.forEach((field) => {
          if (!signatory[field.key as keyof GroupSignatories] as unknown as string) {
            throw new AuthorisedErrors(`${field.label} is required for signatory ${index + 1}`);
          }
          if (
            field.regex &&
            !field.regex.test(signatory[field.key as keyof GroupSignatories] as unknown as string)
          ) {
            throw new AuthorisedErrors(
              field.regexMsg
                ? `${field.regexMsg} for signatory ${index + 1}`
                : `Please enter valid ${field.label} for signatory ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = getActiveSignatories.filter(
              (vsignatory) =>
                (vsignatory[field.key as keyof GroupSignatories] as unknown as string) ===
                (signatory[field.key as keyof GroupSignatories] as unknown as string)
            );
            if (values.length > 1) {
              throw new AuthorisedErrors(
                `There is already same ${field.label} for an Authorised Signatory associated with this application`
              );
            }
          }
        });
      });
      return group;
    });
  } catch (error) {
    if (error instanceof AuthorisedErrors) {
      throw error;
    }
  }
};

const fieldsTocheckForUbos = [
  {
    key: 'panNumber',
    label: 'Taxpayer ID Number/PAN/Equivalent ID Number',
    validateMulitple: true,
    required: true,
  },
  {
    key: 'dob',
    label: 'Date of Birth',
    validateMulitple: false,
    required: true,
  },
  { key: 'name', label: 'Name of UBO', validateMulitple: false, required: true },
  {
    key: 'identificationType',
    label: 'Identification Type',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'percentageOfBeneficialInterest',
    label: 'Percentage of beneficial interest',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'countryOfTaxResidency',
    label: 'Country of Tax Residency',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'cpUboCode',
    label: 'CP/UBO Code',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'placeAndCountryOfBirth',
    label: 'Place & Country of Birth',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'occupation',
    label: 'Occupation',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'gender',
    label: 'Gender',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'nationality',
    label: 'Nationality',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'fatherName',
    label: 'Father Name',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'ckycNumber',
    label: 'CKYC Number',
    validateMulitple: true,
    required: false,
  },
  {
    key: 'address1',
    label: 'Address 1',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'address2',
    label: 'Address 2',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'pincode',
    label: 'Pincode',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'city',
    label: 'City',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'state',
    label: 'State',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'country',
    label: 'Country',
    validateMulitple: false,
    required: true,
  },
];
const validateNonIndividualUbo = async (
  applicants: Partial<Applicant>[],
  ubo_declaration_type: string,
  ubo_declaration_value: string,
  ubos: ubo[],
  nationalityDropdown: string[],
  countryDropdown: string[]
) => {
  try {
    const applicantsCkycNumbers = applicants?.map((applicant) => applicant.ckycNo);
    if (!ubo_declaration_type && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())) {
      throw new UboErrors('Please Select/Add Declaration Type in Declaration of Ubo');
    }
    if (!ubo_declaration_value && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())) {
      throw new UboErrors('Please Select/Add Declaration value in Declaration of Ubo');
    }
    if (ubo_declaration_type === 'none' && !ubos.filter((_item) => _item.isActive).length && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())) {
      throw new UboErrors('Please Add Ultimate Benificiary Owners(UBO)');
    }
    if (ubos.filter((_item) => _item.isActive).length && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())) {
      const activeUbos = ubos.filter((_item) => _item.isActive);
      activeUbos.map((ubo) => {
        if (ubo.ckycNumber && applicantsCkycNumbers.includes(ubo.ckycNumber)) {
          throw new UboErrors(
            `CKYC Number of ${ubo.name} should not be same as CKYC Number exist in Entity Details`
          );
        }
        // if (!nationalityDropdown.includes(ubo.nationality || '')) {
        //   throw new UboErrors(`Invalid Nationality for ${ubo.name} in Declaration of Ubo`);
        // }
        // if (!countryDropdown.includes(ubo.country || '')) {
        //   throw new UboErrors(`Invalid Country for ${ubo.name} in Declaration of Ubo`);
        // }
        // if (!countryDropdown.includes(ubo.countryOfTaxResidency || '')) {
        //   throw new UboErrors(
        //     `Invalid Country of Tax Residency for ${ubo.name} in Declaration of Ubo`
        //   );
        // }
        // if (!occupationDetailsMasters.includes(ubo.occupation || '')) {
        //   throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        // }
        // if (!uboOccupationDetailsMasters.includes(ubo.occupation || '')) {
        //   throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        // }
      });
      percentageError(ubos, true);
    }
    ubos
      .filter((_item) => _item.isActive)
      .forEach((ubo, index) => {
        fieldsTocheckForUbos.forEach((field) => {
          if ((!ubo[field.key as keyof ubo] as unknown as string) && field.required && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())) {
            throw new UboErrors(`${field.label} is required for ubo ${index + 1}`);
          }
          if (
            field.key === 'dob' &&
            (ubo[field.key as keyof ubo] as unknown as string) &&
            isMinor(field.key) && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())
          ) {
            throw new UboErrors(`Age should be greater than 18 for ubo ${index + 1}`);
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof ubo] as unknown as number) <= 0 && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest should be greater 0 for ubo ${index + 1}`
            );
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof ubo] as unknown as number) > 100 && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest must not exceed 100% for ubo ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = ubos.filter(
              (_ubo) =>
                (_ubo[field.key as keyof ubo] as unknown as string) ===
                (ubo[field.key as keyof ubo] as unknown as string) &&
                (ubo[field.key as keyof ubo] as unknown as string) &&
                (_ubo[field.key as keyof ubo] as unknown as string) && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())
            );
            if (values.length > 1 && !ADD_UBO_EXCEPTION.includes(`${applicants[0].investorType || ''}`.toLowerCase())) {
              throw new UboErrors(
                `There is already same ${field.label} for an Ubos associated with this application`
              );
            }
          }
        });
      });
  } catch (e) {
    if (e instanceof UboErrors) {
      throw e;
    }
  }
};
export const nonIndividualFormValidForSubmission = async (
  application: ApplicationProps | null,
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  mdmsCountriesList: dataTypeMasters[],
  verifyPennydrop = true,
  currencyCode = "INR",
  locale = "en-IN",
  validateDoc = true
) => {
  const {
    applicants = [],
    banks = [],
    groups = [],
    ubo_declaration_type = '',
    ubo_declaration_value = '',
    ubos = [],
    applicationType = '',
  } = application || {};
  const nationalityDropdown = mdmsCountriesList.map((list) => list.description);
  const countryDropdown = mdmsCountriesList.map((list) => list.description);
  try {
    await validateNonIndividualContributorDetails(applicants, locale);
    await validateNonIndividualContactDetails(applicants, countryDropdown, currencyCode);
    // await validateBankDetails(banks, verifyPennydrop, applicationType, applicants, currencyCode);
    await validateNonIndividualAuthorisedSignatories(groups);
    await validateNonIndividualUbo(
      applicants,
      ubo_declaration_type,
      ubo_declaration_value,
      ubos,
      nationalityDropdown,
      countryDropdown
    );
    if (validateDoc) {
      await validateNonIndividualDocumentDetails(applicants, documentsData, banks);
    }
  } catch (error) {
    if (error instanceof UboErrors) {
      throw (error as UboErrors).message;
    }
    if (error instanceof AuthorisedErrors) {
      throw (error as AuthorisedErrors).message;
    }
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};


export const updateChequeStatus =
  (body: UpdateChequeStatusRequestBody) =>
    async (dispatch: any): Promise<UpdateChequeStatusResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/update-cheque-status`,
          method: 'POST',
          types: [UPDATE_CHEQUE_STATUS_SUCCESS, UPDATE_CHEQUE_STATUS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const kraReverification =
  (body: KraReverificationRequestBody) =>
    async (dispatch: any): Promise<KraReverificationResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/reVerificationKra`,
          method: 'POST',
          types: [KRA_REVERIFICATION_SUCCESS, KRA_REVERIFICATION],
          body,
        },
      });
    };
